import {
  createStore,
  combineReducers,
  applyMiddleware,
} from 'redux';
import {
  modelReducer,
  formReducer,
} from 'react-redux-form';
import thunk from 'redux-thunk';

import person from '../act/person';

const initialActState = {
  identifier: '',
  contractNumber: '',
  author: person.natural,
  clients: [person.natural],
};

const store = createStore(
  combineReducers({
    act: modelReducer('act', initialActState),
    actForm: formReducer('act', initialActState),
  }),
  applyMiddleware(thunk)
);

export default store;



/** WEBPACK FOOTER **
 ** ./client/app/store.js
 **/